import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Téléchargement immédiat',
  desc: "Achetez et accédez instantanément aux 6 volumes et aux 5 bonus. Commencez quand vous voulez, sans attendre."
}, {
  n: '2',
  title: 'Évaluez et progressez phase par phase',
  desc: "Réalisez le bilan, gérez la phase aiguë et appliquez le renforcement progressif grâce aux critères de chaque étape. Le système est votre feuille de route."
}, {
  n: '3',
  title: 'Retour au sport en toute sécurité',
  desc: "Validez les points de contrôle de retour au sport, puis appliquez le Système A.R.M.A.™ pour éviter toute rechute."
}];
export function Steps() {
  return <section aria-label="Comment ça marche" className="bg-transparent" data-id="element-156" data-mp="fqgzjmd6a43t">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-157" data-mp="261buv7czve14">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-158" data-mp="2a3ynvblej4zw">
          Comment vous allez progresser dès aujourd'hui
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-159" data-mp="1q8zgsth2xaix">En 3 étapes simples</p>

        <ol className="mt-10 space-y-4" data-id="element-160" data-mp="1lbzbwlvyudte">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-161" data-mp="2003ulpv0qpc6" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-162" data-mp="1hae3bcqgslp0">
                {s.n}
              </span>
              <div data-id="element-163" data-mp="2spt0ohml5fkn">
                <h3 className="text-base font-bold text-plum" data-id="element-164" data-mp="2sp1d9u356o5g">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-165" data-mp="2nqq31i8xqbmp">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}